import { useQuery } from '@tanstack/react-query';

import { fetchBatchShopByUsername } from '../api';

import { RQ_BATCH_SHOPS_BY_USERNAMES } from '@/modules/ReactQuery/cacheKeys';

export function useFetchBatchShopByUsername(usernames: string[]) {
  return useQuery({
    queryKey: [RQ_BATCH_SHOPS_BY_USERNAMES, usernames],
    queryFn: () => fetchBatchShopByUsername(usernames, true),
    enabled: usernames.length > 0,
  });
}
